module.exports = __webpack_public_path__ + "img/problem_cover_01.fc8a9537.jpg";